module.exports = __webpack_public_path__ + "img/block0Img05.4f2654dd.png";